<section class="relative md:py-24 py-16">
    <div class="container">
        <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">

            <div class="block md:hidden col-span-1">
              <div class="sticky top-20">
                  <h5 class="text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center">Team</h5>
                  <div class="text-center mt-8">
                      <img src={{member?.foto}} class="h-60 w-60 object-cover mx-auto rounded-full shadow mb-4" alt="">

                      <a href="" class="text-lg font-medium hover:text-emerald-600 transition-all duration-500 ease-in-out h5">{{ member?.voornaam + ' ' + member?.achternaam }}</a>
                      <p class="text-slate-400">{{member?.rol}}</p>
                      <a class="text-earth-xdark" href="mailto:{{member?.email}}">{{member?.email}}</a>
                  </div>
              </div>
            </div>

            <div class="lg:col-span-8 md:col-span-6">
                <div class="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">

                    <!--<img src="assets/images/blog/09.jpg" alt="">-->

                    <div class="p-6 omschrijving">{{member?.beschrijving}}</div>

                </div>
            </div>

            <div class="lg:col-span-4 md:col-span-6">
                <div class="sticky top-20">
                    <h5 class="hidden md:block text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center">Team</h5>
                    <div class="hidden md:block text-center mt-8">
                        <img src={{member?.foto}} class="h-60 w-60 object-cover mx-auto rounded-full shadow mb-4" alt="">

                        <a href="" class="text-lg font-medium hover:text-emerald-600 transition-all duration-500 ease-in-out h5">{{ member?.voornaam + ' ' + member?.achternaam }}</a>
                        <p class="text-slate-400">{{member?.rol}}</p>
                        <a class="text-earth-xdark" href="mailto:{{member?.email}}">{{member?.email}}</a>
                    </div>

                    <h5 class="text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center mt-8">Discipline</h5>
                    <ul class="list-none text-center mt-8">
                        <li class="inline" *ngFor="let disc of member?.disciplines">
                          <i data-feather="uil-arrow-right" class="h-4 w-4"></i> {{ disc.naam }}
                        </li>
                    </ul><!--end icon-->

                    <h5 class="text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center mt-8">Specialisaties</h5>
                    <ul class="list-none text-center mt-8">
                        <li *ngFor="let spec of member?.specialisaties">
                          <i data-feather="uil-arrow-right" class="h-4 w-4"></i> {{ spec.naam }}
                        </li>
                    </ul><!--end icon-->

                    <h5 class="text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center mt-8">Praktijken</h5>
                    <ul class="list-none text-center mt-8">
                        <li class="inline side-line" *ngFor="let v of member?.vestigingen">
                          <i class="uil uil-map-marker"></i> {{ v.naam }}<br />
                          <a [href]="'mailto:' + v.email">{{v.email}}</a>
                        </li>
                    </ul><!--end icon-->
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-16">
      <div class="grid grid-cols-1">
          <div class="relative overflow-hidden lg:px-8 px-6 py-10 rounded-xl shadow-lg dark:shadow-gray-700">
              <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                  <div class="lg:col-span-8 md:col-span-7">
                      <div class="ltr:md:text-left rtl:md:text-right text-center relative z-1">
                          <h3 class="text-2xl font-semibold text-black dark:text-white mb-4">Join our team!</h3>
                          <p class="text-slate-400 max-w-xl">Heb jij de juiste competenties en wil je ons team versterken? Neem contact op met <a class='underline text-earth-xdark' href='/contact'>één van onze vestigingen</a>!</p>
                      </div>
                  </div>

                  <div class="lg:col-span-4 md:col-span-5">
                      <div class="ltr:text-right rtl:text-left relative z-1">
                          <a [routerLink]="['/vacatures']" class="btn bg-earth-dark/80 hover:bg-earth-dark border-earth-common text-black/70 rounded-md">Ik kom er bij!</a>
                          <a [routerLink]="['/vacatures']" class="btn bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 rounded-md ltr:ml-2 rtl:mr-2">Bekijk vacatures</a>
                      </div>
                  </div>
              </div>

              <div class="absolute -top-5 ltr:-left-5 rtl:-right-5">
                  <div class="uil uil-envelope lg:text-[150px] text-7xl text-black/5 dark:text-white/5 ltr:-rotate-45 rtl:rotate-45"></div>
              </div>

              <div class="absolute -bottom-5 ltr:-right-5 rtl:-left-5">
                  <div class="uil uil-pen lg:text-[150px] text-7xl text-black/5 dark:text-white/5 rtl:-rotate-90"></div>
              </div>
          </div>
      </div>
    </div>
</section><!--end section-->
